<template>
    <footer class="footer-basic">
        <div class="container">
            <div class="social">
                <a class="instagram-container" href="https://www.instagram.com/olivia.prirodni.sapuni/?hl=en" target="_blank"><font-awesome-icon class="instagram" :icon="['fab', 'instagram']"/></a>
                <a class="facebook-container" href="https://www.facebook.com/olivia.prirodni.sapuni" target="_blank"><font-awesome-icon class="facebook" :icon="['fab', 'facebook']"/></a>
                <a class="youtube-container" href="#" target="_blank"><font-awesome-icon class="youtube" :icon="['fab', 'youtube']"/></a>
            </div>
            <ul class="list-inline">
                <li class="list-inline-item"><router-link to="/paymentanddelivery">Dostava i plaćanje</router-link></li>
                <li class="list-inline-item"><router-link to="/complaint">Reklamacija i povraćaj robe</router-link></li>
                <li class="list-inline-item"><router-link to="/privacyprotection">Zaštita privatnosti</router-link></li>
                <li class="list-inline-item"><router-link to="/customerrights">Prava i obaveze potrošača</router-link></li>
            </ul>
            <p class="copyright">Olivia © 2021</p>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'Footer'
}
</script>

<style scoped>
.footer-basic {
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    padding: 40px 0;
    background-color: #F0EAD6;
}

.youtube {
    color: #FF0000;
}

.youtube-container {
    border: 1px solid #FF0000;
}

.facebook {
    color: #4267B2
}

.facebook-container {
    border: 1px solid #4267B2;
}

.instagram {
    color: #C13584;
}

.instagram-container {
    border: 1px solid #C13584;
}

.footer-basic ul {
    padding: 0;
    list-style: none;
    text-align: center;
    font-size: 18px;
    line-height: 1.6;
    margin-bottom: 0;
    margin-right: auto;
    margin-left: auto;
}

.footer-basic li {
    padding: 0 10px;
}

.footer-basic ul a {
    color: inherit;
    text-decoration: none;
    opacity: 0.5;
}

.footer-basic ul a:hover {
    opacity: 0.9;
}

.footer-basic .social {
    text-align: center;
    padding-bottom: 25px;
}

.footer-basic .social > a {
    font-size: 24px;
    width: 40px;
    height: 40px;
    line-height: 40px;
    display:inline-block;
    text-align: center;
    border-radius: 50%;
    margin: 0 8px;
    color: inherit;
    opacity: 0.75;
}

.footer-basic .social > a:hover {
    opacity: 0.9;
}

.footer-basic .copyright {
    margin-top: 15px;
    text-align: center;
    font-size: 13px;
    color: #aaa;
    margin-bottom: 0;
}
</style>